import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {Information} from '../../../model/information';
import {InformationsService} from '../../../services/informations.service';
import {InformationType} from '../../../model/InformationType';
import {Router, RouterLink} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

import {InfoBlockComponent} from "../../../components/common/info-block/info-block.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {CancelButtonComponent} from "../../../components/common/cancel-button/cancel-button.component";

@Component({
    selector: 'app-ticket-read-info',
    imports: [
    InfoBlockComponent,
    FaIconComponent,
    CancelButtonComponent,
    RouterLink
],
    templateUrl: './ticket-read-info.component.html',
    styleUrls: ['./ticket-read-info.component.css']
})
export class TicketReadInfoComponent implements OnInit {

  infos: Information[];
  @ViewChild('latestinfosmodal') latestinfosmodal: TemplateRef<any>;

  @Input() set check(value: boolean) {
    if (value) {
      this.checkLatestInfos();
    }
  }

  @Output() checkChange = new EventEmitter<boolean>();

  constructor(private informationsService: InformationsService, private router: Router, private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.informationsService.getObjects().subscribe(infos => {
      this.infos = infos.filter(i => i.type === InformationType.DIRECT);
    });
  }

  checkLatestInfos(): void {
    if (this.infos.length === 0) {
      this.router.navigate(['/tickets/nouveau']);
    } else {
      this.modalService.open(this.latestinfosmodal, {size: 'lg'}).result.then(() => {
        this.router.navigate(['/tickets/nouveau']);
      }).catch(() => {
        this.checkChange.emit(false);
        // Do nothing
      });
    }
  }

}
